import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, {
  Path,
  G,
  Defs,
  Circle,
  Stop,
  LinearGradient,
} from "react-native-svg";

import { uniqueId } from "lodash";

import { isWeb } from "../../../../../helpers/utils";

export default function MariLookUpIcon({ onPress }) {
  const filterId = "filter0_d_MariLookUpIcon" + uniqueId();
  const gradientId = "paint0_linear_MariLookUpIcon" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";

  return (
    <TouchableOpacity onPress={onPress}>
      <Svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G filter={filterUrl}>
          <Circle cx="33" cy="29" r="28" fill={gradientUrl} />
          <Path
            d="M23.0337 35.9194C25.5239 39.551 33.2426 40.7488 36.3001 35.3262"
            stroke="#233151"
            strokeWidth="1.48535"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M21.2441 23.0439C21.2441 24.505 20.0597 25.6894 18.5986 25.6894C17.1376 25.6894 15.9531 24.505 15.9531 23.0439C15.9531 21.5828 17.1376 20.3984 18.5986 20.3984C20.0597 20.3984 21.2441 21.5828 21.2441 23.0439Z"
            fill="#233151"
          />
          <Path
            opacity="0.61"
            d="M18.752 22.0261C18.752 22.4009 18.4482 22.7047 18.0735 22.7047C17.6987 22.7047 17.395 22.4009 17.395 22.0261C17.395 21.6513 17.6987 21.3477 18.0735 21.3477C18.4482 21.3477 18.752 21.6513 18.752 22.0261Z"
            fill="white"
          />
          <Path
            d="M14.7305 15.8626C16.7403 13.2002 20.3335 13.2004 22.0735 15.9046"
            stroke="#233151"
            strokeWidth="1.48851"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M42.414 23.2978C42.414 24.7589 41.2296 25.9433 39.7685 25.9433C38.3075 25.9433 37.123 24.7589 37.123 23.2978C37.123 21.8367 38.3075 20.6523 39.7685 20.6523C41.2296 20.6523 42.414 21.8367 42.414 23.2978Z"
            fill="#233151"
          />
          <Path
            opacity="0.61"
            d="M39.8072 22.28C39.8072 22.6548 39.5034 22.9586 39.1288 22.9586C38.754 22.9586 38.4502 22.6548 38.4502 22.28C38.4502 21.9052 38.754 21.6016 39.1288 21.6016C39.5034 21.6016 39.8072 21.9052 39.8072 22.28Z"
            fill="white"
          />
          <Path
            d="M36.4385 15.9527C37.1745 14.9647 38.43 14.388 39.6591 14.4731C40.8883 14.5583 42.0522 15.3026 42.645 16.3827"
            stroke="#233151"
            strokeWidth="1.48851"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M50.1782 11.3423V39.5849C50.1782 40.8776 49.1286 41.9272 47.8359 41.9272H11.3423C10.0496 41.9272 9 40.8776 9 39.5849V11.3423C9 10.0496 10.0496 9 11.3423 9H47.8359C49.1286 9 50.1782 10.0496 50.1782 11.3423Z"
            stroke="black"
            strokeOpacity="0.01"
            strokeWidth="0.0117113"
          />
        </G>
        <Defs>
          {isWeb ? (
            <filter
              id={filterId}
              x="0"
              y="0"
              width="66"
              height="66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          ) : null}
          <LinearGradient
            id={gradientId}
            x1="5"
            y1="1"
            x2="44.4204"
            y2="45.7669"
            gradientUnits="userSpaceOnUse"
          >
            <Stop offset="0.374593" stopColor="#00FFD1" />
            <Stop offset="1" stopColor="#239C9D" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
